import React, { CSSProperties } from 'react';
import clsx from 'clsx';

import { FormattedMessage } from '@futrli/localisation';

import styles from './consolidation-instructions.scss';

interface ConsolidationInstructionsProps {
  className?: string;
  style?: CSSProperties;
}

export const ConsolidationInstructions = ({ className, style }: ConsolidationInstructionsProps) => {
  return (
    <div className={clsx(styles.container, className)} style={style} data-testid="consolidation-import-instructions">
      <h2 className={clsx(styles.title)}>
        <FormattedMessage id="predict.available_templates" defaultMessage="Available templates" />
      </h2>
      <p className={styles.text}>
        <FormattedMessage
          id="predict.to_use_google_sheets_import_templates"
          defaultMessage="To use Google Sheets import templates:"
        />
        <ol className={styles.list}>
          <li className={styles.listitem}>
            <FormattedMessage
              id="predict.open_sub_entity_sheet"
              defaultMessage="Open a sub-entity sheet above and the required template below."
            />
          </li>
          <li className={styles.listitem}>
            <FormattedMessage
              id="predict.copy_template_into_sub_entity_sheet"
              defaultMessage="Copy the template into the sub-entity sheet."
            />
          </li>
          <li className={styles.listitem}>
            <FormattedMessage id="predict.edit_values" defaultMessage="Edit values." />
          </li>
          <li className={styles.listitem}>
            <FormattedMessage
              id="predict.hit_sync_button_update_forecast"
              defaultMessage="Hit the sync button above to update the forecast with new values."
            />
          </li>
        </ol>
      </p>
    </div>
  );
};
